import { render, staticRenderFns } from "./base-menu.vue?vue&type=template&id=491b9408"
import script from "./base-menu.ts?vue&type=script&lang=ts&external"
export * from "./base-menu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491b9408')) {
      api.createRecord('491b9408', component.options)
    } else {
      api.reload('491b9408', component.options)
    }
    module.hot.accept("./base-menu.vue?vue&type=template&id=491b9408", function () {
      api.rerender('491b9408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Menu/base-menu.vue"
export default component.exports